import { useState, useEffect } from 'react';
import Icon from '../AppIcon';
import Select from '../ui/Select';

const LocationIndicator = ({ className = '' }) => {
  const [isLocationModalOpen, setIsLocationModalOpen] = useState(false);
  const [currentCity, setCurrentCity] = useState('Manila');
  const [searchRadius, setSearchRadius] = useState('10');

  const philippineCities = [
    { value: 'manila', label: 'Manila' },
    { value: 'quezon-city', label: 'Quezon City' },
    { value: 'caloocan', label: 'Caloocan' },
    { value: 'davao', label: 'Davao City' },
    { value: 'cebu', label: 'Cebu City' },
    { value: 'zamboanga', label: 'Zamboanga City' },
    { value: 'taguig', label: 'Taguig' },
    { value: 'antipolo', label: 'Antipolo' },
    { value: 'pasig', label: 'Pasig' },
    { value: 'cagayan-de-oro', label: 'Cagayan de Oro' },
  ];

  const radiusOptions = [
    { value: '5', label: '5 km' },
    { value: '10', label: '10 km' },
    { value: '25', label: '25 km' },
    { value: '50', label: '50 km' },
    { value: '100', label: '100 km' },
  ];

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation?.getCurrentPosition(
        (position) => {
          console.log('Location detected:', position?.coords);
        },
        (error) => {
          console.log('Location detection failed:', error);
        }
      );
    }
  }, []);

  const handleCityChange = (value) => {
    const selectedCity = philippineCities?.find(city => city?.value === value);
    if (selectedCity) {
      setCurrentCity(selectedCity?.label);
    }
  };

  const handleRadiusChange = (value) => {
    setSearchRadius(value);
  };

  const handleApplyLocation = () => {
    setIsLocationModalOpen(false);
  };

  return (
    <>
      <button
        onClick={() => setIsLocationModalOpen(true)}
        className={`
          flex items-center gap-[8px] px-[12px] py-[8px] rounded-md
          bg-muted hover:bg-muted/80 transition-smooth
          text-foreground text-[14px] font-medium
          ${className}
        `}
        aria-label="Change location"
      >
        <Icon name="MapPin" size={16} color="var(--color-primary)" />
        <span className="hidden sm:inline">{currentCity}</span>
        <Icon name="ChevronDown" size={14} />
      </button>
      {isLocationModalOpen && (
        <div 
          className="fixed inset-0 z-modal bg-background flex items-start justify-center pt-[8vh] px-[16px]"
          onClick={() => setIsLocationModalOpen(false)}
        >
          <div 
            className="bg-card rounded-[18px] shadow-warm-xl w-full max-w-[480px] p-[30px] animate-in fade-in zoom-in-95 duration-250"
            onClick={(e) => e?.stopPropagation()}
          >
            <div className="flex items-center justify-between mb-[24px]">
              <h3 className="text-xl font-heading font-semibold text-foreground">
                Set Your Location
              </h3>
              <button
                onClick={() => setIsLocationModalOpen(false)}
                className="p-[6px] rounded-md hover:bg-muted transition-smooth"
                aria-label="Close location settings"
              >
                <Icon name="X" size={20} />
              </button>
            </div>

            <div className="space-y-[18px]">
              <Select
                label="City"
                description="Select your current city or preferred location"
                options={philippineCities}
                value={philippineCities?.find(city => city?.label === currentCity)?.value}
                onChange={handleCityChange}
                searchable
              />

              <Select
                label="Search Radius"
                description="How far are you willing to travel for work?"
                options={radiusOptions}
                value={searchRadius}
                onChange={handleRadiusChange}
              />

              <div className="flex items-center gap-[12px] p-[18px] bg-muted rounded-md">
                <Icon name="Info" size={20} color="var(--color-primary)" />
                <p className="text-[14px] text-muted-foreground">
                  Jobs and services will be filtered based on your location preferences
                </p>
              </div>

              <div className="flex gap-[12px] pt-[12px]">
                <button
                  onClick={() => setIsLocationModalOpen(false)}
                  className="flex-1 px-[24px] py-[12px] rounded-md border border-border
                    text-foreground font-medium transition-smooth hover:bg-muted"
                >
                  Cancel
                </button>
                <button
                  onClick={handleApplyLocation}
                  className="flex-1 px-[24px] py-[12px] rounded-md bg-primary
                    text-primary-foreground font-medium transition-smooth hover:opacity-90"
                >
                  Apply
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LocationIndicator;